module.exports = __webpack_public_path__ + "img/img3.d59a8025.svg";